import React from 'react';
import BaseLayout from '../../components/layout';
import Content from '../../components/content';

const Home = () => {
	return (
		<BaseLayout title="Corona Virus Statistics">
			<Content />
		</BaseLayout>
	);
};

export default Home;
